import React, { useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import { Delete } from "@mui/icons-material";
import toast from "react-hot-toast";
import { FaImages } from "react-icons/fa";
import GhlMediaGallery from "components/GhlMediaGallery";
import "./accountDetailTabs.css";

function Attachments({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [loadingButton, setLoadingButton] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [ghlGalleryOpen, setGhlGalleryOpen] = useState(false);

  useEffect(() => {
    if (formData?.attachments?.length) {
      setAttachments(formData.attachments);
    }
  }, [formData]);

  const handleDelete = async (index, imageId) => {
    const newAttachments = attachments.filter((_, i) => i !== index);
    setAttachments(newAttachments);

    const payload = { _id: formData.id, attachments: newAttachments, ...(imageId && { old_image_id: imageId }) };
    const { response } = await AppService.accounts.update({ payload });

    if (response) {
      handleRefresh();
      toast.success("Delete Successfully");
    } else {
      toast.error("Error deleting attachment");
    }
  };

  const handleGhlImagesSelect = async (urls) => {
      console.log(urls);
    if (!urls?.length) return;
    setLoadingButton(true);
    try {
      const newAttachments = [...attachments, ...urls];
      const payload = { _id: formData.id, attachments: newAttachments };
      const { response } = await AppService.accounts.update({ payload });
      if (response) {
        setAttachments(newAttachments);
        toast.success(
          `${urls.length} image${urls.length > 1 ? "s" : ""} added`
        );
      } else {
        toast.error("Error updating attachments");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to add images");
    } finally {
      setLoadingButton(false);
    }
  };

  return (
    <div className="sd-account-detail-tab">
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
          marginBottom: "20px",
        }}
      >
        <button
          type="button"
          onClick={() => setGhlGalleryOpen(true)}
          disabled={loadingButton}
          title="Choose from Media"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            border: "none",
            background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
            color: "white",
            padding: "10px 18px",
            borderRadius: "10px",
            cursor: loadingButton ? "default" : "pointer",
            fontSize: "13px",
            fontWeight: 600,
            whiteSpace: "nowrap",
            boxShadow: "0 2px 6px rgba(25, 118, 210, 0.35)",
            opacity: loadingButton ? 0.7 : 1,
          }}
        >
          <FaImages size={16} />
          {loadingButton ? "Saving..." : "Select from Media"}
        </button>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {attachments?.map((attachment, index) => (
          <div key={index} style={{ position: "relative" }}>
            <div
              onClick={() => handleDelete(index, attachment?._id)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
                color: "red",
                background: "white",
                padding: "5px",
                borderRadius: "4px",
              }}
            >
              <Delete />
            </div>
            <img src={attachment?.url || attachment} alt="attachment" width={300} />
          </div>
        ))}
      </div>

      <GhlMediaGallery
        open={ghlGalleryOpen}
        onClose={() => setGhlGalleryOpen(false)}
        onSelect={handleGhlImagesSelect}
        title="Select Images"
        confirmLabel="Add to Attachments"
        googlePlaceId={formData?.google_place_id}
        multiSelect
      />
    </div>
  );
}

export default Attachments;
